import { Dispatch, SetStateAction, createContext } from 'react';
import { ExecutionHistory } from 'pages/AutomationEngine/types';

export type ExecutionHistoryContextType = {
  historyId: string | null;
  orderedExecutionHistory: ExecutionHistory[];
  selectedHistoryStepIndex: number;
  showHistorySideBar: boolean;
  setSelectedHistoryStepIndex: Dispatch<SetStateAction<number>>;
  setHistoryId: Dispatch<SetStateAction<string | null>>;
  setShowHistorySideBar: Dispatch<SetStateAction<boolean>>;
  setOrderedExecutionHistory: Dispatch<SetStateAction<any[]>>;
  getSelectedHistoryStep: () => ExecutionHistory | undefined;
};

export const defaultContext: ExecutionHistoryContextType = {
  historyId: null,
  orderedExecutionHistory: [],
  selectedHistoryStepIndex: 0,
  showHistorySideBar: false,
  setSelectedHistoryStepIndex: () => {},
  setHistoryId: () => {},
  setShowHistorySideBar: () => {},
  setOrderedExecutionHistory: () => {},
  getSelectedHistoryStep: (): ExecutionHistory | undefined => {
    return undefined;
  },
};

export const ExecutionHistoryContext =
  createContext<ExecutionHistoryContextType>(defaultContext);
